import {Swiper, Navigation, Thumbs, Pagination, Zoom} from 'asteq.swiper';
import {BaseDetailSlider} from 'asteq.sliders.basedetailslider';

function getSwiperSlideElements(swiper, swiperBlock) {
    if (swiper?.slides?.length) {
        return swiper.slides;
    }

    const wrapper = swiper?.wrapperEl
        || swiperBlock?.querySelector('.swiper-wrapper');

    return wrapper ? Array.from(wrapper.children) : [];
}

export class DetailModalSlider extends BaseDetailSlider {
    constructor(sliderBlock, params) {
        super(sliderBlock, params);
        this.omitImageDimensions = true;
    }

    initSwipers() {
        if (this.thumbsSwiperBlock) {
            this.thumbsSwiper = new Swiper(this.thumbsSwiperBlock,
                {
                    spaceBetween: 16,
                    slidesPerView: 4,
                    freeMode: !0,
                    breakpoints: {
                        1280: {
                            spaceBetween: 22
                        }
                    },
                },
            );

            const thumbSlides = getSwiperSlideElements(this.thumbsSwiper, this.thumbsSwiperBlock);
            for (let i = 0; i < thumbSlides.length; i++) {
                const thumbSlide = thumbSlides[i];
                if (this.isGallery360ThumbSlide(thumbSlide)) {
                    this.gallery360ThumbMarkup = thumbSlide.outerHTML;
                    const thumbImg = thumbSlide.querySelector('.gallery-360-thumb__img');
                    if (thumbImg && thumbImg.src) {
                        this.gallery360ThumbPoster = thumbImg.src;
                    }
                    continue;
                }
                if (!this.thumbsSwiperSlideTemplate) {
                    this.thumbsSwiperSlideTemplate = thumbSlide.cloneNode(true);
                }
            }
        }

        if (this.mainSwiperBlock) {
            let thumbsParams = null;
            if (this.thumbsSwiper) {
                thumbsParams = {
                    swiper: this.thumbsSwiper,
                    slideThumbActiveClass: "!opacity-100",
                };
            }

            this.mainSwiper = new Swiper(this.mainSwiperBlock, {
                modules: [Navigation, Thumbs, Zoom],
                navigation: {
                    prevEl: this.mainSwiperBlock.querySelector('.swiper-button-prev.swiper-main-navigation'),
                    nextEl: this.mainSwiperBlock.querySelector('.swiper-button-next.swiper-main-navigation'),
                },
                thumbs: thumbsParams,
                zoom: {
                    maxRatio: 2,
                },
                on: {
                    zoomChange: (n, r, s) => {
                        s.classList.toggle("!cursor-grab");
                    },
                },
            });

            const mainSlides = getSwiperSlideElements(this.mainSwiper, this.mainSwiperBlock);
            for (let i = 0; i < mainSlides.length; i++) {
                const slide = mainSlides[i];
                if (this.isGallery360MainSlide(slide)) {
                    this.gallery360SlideTemplate = slide.cloneNode(true);
                    this.gallery360Enabled = true;
                    continue;
                }
                if (!this.mainSwiperSlideTemplate) {
                    this.mainSwiperSlideTemplate = slide.cloneNode(true);
                }
            }
        }

        if (this.thumbsSwiper) {
            this.thumbsSwiper.update();
        }
    }
}
